import {Button, Stack, Typography} from '@mui/material';
import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {WhatCanRefundModalProps} from './types';

const {description, subtitle, title} =
	translations['pt-br'].privateFlow.refund.beneficiaryDataPage.modals.whatCanRefund;

const {understood} = translations['pt-br'].commons;

export const WhatCanRefundModal = ({open, setOpen}: WhatCanRefundModalProps) => (
	<Modal.Root open={open} onClose={() => setOpen(false)}>
		<Modal.Header title={title} onClose={() => setOpen(false)} />
		<Modal.Content>
			<Stack spacing={2}>
				<Typography variant="h6">{subtitle}</Typography>

				<Typography variant="body1">{description}</Typography>
			</Stack>
		</Modal.Content>

		<Modal.Footer>
			<Button
				fullWidth
				variant="contained"
				size="large"
				color="primary"
				onClick={() => setOpen(false)}>
				{understood}
			</Button>
		</Modal.Footer>
	</Modal.Root>
);
